/* Eiken — tiroir de menu mobile en panneaux coulissants (28/09/2026, lot 3,
   revu le 28/09 apres relecture senior).
   Markup : snippets/drawer-menu.liquid. Un panneau racine + un panneau par
   entree ayant des enfants ; [data-nav-push="id"] ouvre un panneau,
   [data-nav-back] revient au parent (data-nav-parent). Les panneaux inactifs
   sont `inert` et aria-hidden ; le focus suit (bouton retour a l'aller, ligne
   d'origine au retour). data-nav-initial ouvre la branche de la page courante
   sans animation, a chaque ouverture du tiroir (pas de memoire du dernier
   panneau visite). Le tiroir est un dialog : Tab boucle a l'interieur
   (Motion ne piege que Maj+Tab sur le premier element), Echap est gere par
   Motion. Re-initialise sur shopify:section:load (editeur de theme). */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function init() {
    var drawer = document.getElementById('NavDrawer');
    if (!drawer || drawer.getAttribute('data-eiken-nav-ready') === '1') return;
    var track = drawer.querySelector('[data-nav-track]');
    if (!track) return;
    drawer.setAttribute('data-eiken-nav-ready', '1');

    var panels = {};
    var origin = {};
    var current = 'root';
    var busyUntil = 0;
    var initial = track.getAttribute('data-nav-initial') || 'root';

    track.querySelectorAll('[data-nav-panel]').forEach(function (p) {
      panels[p.getAttribute('data-nav-panel')] = p;
    });
    if (!panels[initial]) initial = 'root';

    function ancestors(id) {
      var out = [], p = panels[id];
      while (p && p.getAttribute('data-nav-parent')) {
        var parentId = p.getAttribute('data-nav-parent');
        out.push(parentId);
        p = panels[parentId];
      }
      return out;
    }

    function setPanel(id, animate) {
      var target = panels[id];
      if (!target) return;
      var behind = ancestors(id);
      if (!animate) track.classList.add('is-static');

      Object.keys(panels).forEach(function (key) {
        var p = panels[key];
        var active = key === id;
        var isBehind = behind.indexOf(key) !== -1;
        p.classList.toggle('is-active', active);
        p.classList.toggle('is-behind', isBehind);
        p.classList.toggle('is-ahead', !active && !isBehind);
        if (active) {
          p.removeAttribute('inert');
          p.removeAttribute('aria-hidden');
        } else {
          p.setAttribute('inert', '');
          p.setAttribute('aria-hidden', 'true');
        }
      });

      drawer.querySelectorAll('[data-nav-push]').forEach(function (btn) {
        var opens = btn.getAttribute('data-nav-push');
        btn.setAttribute('aria-expanded', opens === id || behind.indexOf(opens) !== -1 ? 'true' : 'false');
      });

      track.setAttribute('data-nav-current', id);
      current = id;
      busyUntil = animate ? Date.now() + 300 : 0;

      if (!animate) {
        void track.offsetWidth;
        track.classList.remove('is-static');
      }
    }

    // viaKeyboard : le focus n'est deplace que pour la navigation au clavier.
    // Au doigt ou a la souris, un focus programme affichait l'anneau du
    // navigateur (deux traits sombres autour du titre du panneau).
    function push(id, btn, viaKeyboard) {
      var target = panels[id];
      if (!target || id === current || Date.now() < busyUntil) return;
      origin[id] = btn || null;
      target.scrollTop = 0;
      setPanel(id, !reduceMotion);
      if (viaKeyboard) focusInto(target, target.querySelector('[data-nav-back]'));
      else if (document.activeElement && drawer.contains(document.activeElement)) document.activeElement.blur();
      drawer.dispatchEvent(new CustomEvent('eikenNav:push', { detail: { panel: id } }));
    }

    function back(viaKeyboard) {
      var p = panels[current];
      if (!p || Date.now() < busyUntil) return;
      var parentId = p.getAttribute('data-nav-parent');
      if (!parentId) return;
      var from = current;
      setPanel(parentId, !reduceMotion);
      if (viaKeyboard) focusInto(panels[parentId], origin[from]);
      else if (document.activeElement && drawer.contains(document.activeElement)) document.activeElement.blur();
      drawer.dispatchEvent(new CustomEvent('eikenNav:back', { detail: { panel: from, to: parentId } }));
    }

    function focusInto(panel, el) {
      var target = el || panel.querySelector(FOCUSABLE);
      if (!target) return;
      window.setTimeout(function () {
        try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
      }, reduceMotion ? 0 : 300);
    }

    function visibleFocusables() {
      return Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
        if (el.closest('[inert]')) return false;
        return el.offsetParent !== null || el === document.activeElement;
      });
    }

    drawer.addEventListener('click', function (evt) {
      var pushBtn = evt.target.closest('[data-nav-push]');
      // evt.detail === 0 : clic declenche au clavier (Entree / Espace).
      var kb = evt.detail === 0;
      if (pushBtn) { evt.preventDefault(); push(pushBtn.getAttribute('data-nav-push'), pushBtn, kb); return; }
      var backBtn = evt.target.closest('[data-nav-back]');
      if (backBtn) { evt.preventDefault(); back(kb); }
    });

    drawer.addEventListener('keydown', function (evt) {
      // Fleche gauche sur un panneau enfant = retour au parent.
      if (evt.key === 'ArrowLeft' && current !== 'root' && !evt.target.matches('input, textarea')) {
        evt.preventDefault();
        back(true);
        return;
      }
      // Tab boucle dans le tiroir (elements visibles hors panneaux inertes).
      if (evt.key === 'Tab') {
        var list = visibleFocusables();
        if (!list.length) return;
        var first = list[0], last = list[list.length - 1];
        if (evt.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
          evt.preventDefault(); last.focus();
        } else if (!evt.shiftKey && document.activeElement === last) {
          evt.preventDefault(); first.focus();
        }
      }
    });

    // A chaque ouverture : la branche de la page courante, sans animation.
    document.addEventListener('drawerOpen.NavDrawer', function () {
      if (current !== initial) setPanel(initial, false);
      var firstRow = panels[initial] && panels[initial].querySelector(FOCUSABLE);
      if (firstRow && panels[initial] !== panels.root) {
        window.setTimeout(function () { try { firstRow.focus({ preventScroll: true }); } catch (e) {} }, 50);
      }
    });

    setPanel(initial, false);

  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target && evt.target.querySelector('#NavDrawer')) init();
  });
})();
